Splide.defaults = {
  snap: false,
  easing: 'cubic-bezier(.38,0,.57,1)',
  drag: 'free',
  lazyLoad: 'nearby'
};

const featuredCollections = document.querySelector('.featured-collections-splide');

if (featuredCollections) {
  new Splide(featuredCollections, {
    lazyLoad: false,
    pagination: false,
    type: 'loop',
    perPage: 3,
    perMove: 1,
    focus: 'center',
    arrows: true,
    breakpoints: {
      1024: {
        arrows: false,
        padding: { left: 0, right: 0 },
      },
    },
  }).mount();
}


document.addEventListener('DOMContentLoaded', () => {
  const splideContainer = document.querySelector('.splide.card-testimonials-splide');

  if (splideContainer !== null) {
    new Splide(splideContainer, {
      autoplay: false,
      type: 'loop',
      perPage: 3,
      perMove: 1,
      snap: true,
      arrows: true,
      pagination: true,
      breakpoints: {
        640: {
          perPage: 1,
        },
      },

    }).mount();
  }

  const slidingItems = document.querySelectorAll('.sliding-items');

  if (slidingItems.length !== 0) {
    slidingItems.forEach((item) => {
      const gap = Number(item.dataset.gap);
      const blocksMobile = Number(item.dataset.blocksMobile);
      const blocksDesktop = Number(item.dataset.blocksDesktop);

      new Splide(item, {
        arrows: false,
        pagination: false,
        perPage: blocksDesktop,
        type: 'slide',
        gap: gap,
        breakpoints: {
          768: {
            perPage: blocksMobile,
            padding: { left: '1.5rem', right: '1.5rem' },
          },
        },
      }).mount();
    });
  }

  const jumpBannerSplide = document.querySelectorAll('.jump-slideshow.splide');
  if (jumpBannerSplide.length !== 0) {
    jumpBannerSplide.forEach((item) => {
      new Splide(item, {
        arrows: false,
        pagination: true,
        type: 'slide',
        autoplay: true,
        interval: 4000,
        pauseOnHover: true,
        rewind: true,
      }).mount();
    });
  }

  const slidingCards = document.querySelectorAll('.sliding-cards');

  if (slidingCards.length !== 0) {
    slidingCards.forEach((slidingCard) => {
      const gap = Number(slidingCard.dataset.gap);
      const blocksMobile = Number(slidingCard.dataset.blocksMobile);
      const blocksDesktop = Number(slidingCard.dataset.blocksDesktop);

      new Splide(slidingCard, {
        arrows: false,
        pagination: false,
        perPage: blocksDesktop,
        type: 'slide',
        gap: gap,
        breakpoints: {
          768: {
            perPage: blocksMobile,
            padding: { right: '5rem' },
          },
        },
      }).mount();
    });
  }

  const featuredProducts = document.querySelectorAll('.featured_product_media');

  if (featuredProducts.length !== 0) {
    featuredProducts.forEach((media) => {
      new Splide(media, {
        arrows: false,
        pagination: false,
        perPage: 1,
        type: 'loop',
        gap: 4,
        padding: { left: '2rem', right: '2rem' },
      }).mount();
    });
  }
});

document.addEventListener('build-recommendations', () => {
  const relatedProducts = document.querySelector('.jump-related-products');

  if (relatedProducts) {
    new Splide(relatedProducts, {
      pagination: false,
      type: 'loop',
      perPage: 3,
      perMove: 1,
      focus: 'center',
      arrows: true,
      breakpoints: {
        1024: {
          arrows: false,
          padding: { left: 0, right: 0 },
        },
      },

    }).mount();
  }
  const recommendationContainer = document.querySelector('.contains-card.splide');

  if (recommendationContainer !== null) {
    new Splide(recommendationContainer, {
      type: 'slide',
      perMove: 1,
      fixedWidth: 338,
      arrows: false,
      pagination: false,
      gap: 10,
      mediaQuery: 'min',
      padding: { left: 12, right: 12 },
      breakpoints: {
        768: {
          padding: { left: 40, right: 40 },
        },
        1280: {
          arrows: true,
          padding: { left: 0, right: 0 },
        },
      },

    }).mount();
  }
});

const featuredProducts = document.querySelectorAll('.featured-products-splide');

if (featuredProducts) {
  featuredProducts.forEach((section) => {
    new Splide(section, {
      pagination: false,
      type: 'loop',
      perPage: 3,
      perMove: 1,
      arrows: true,
      breakpoints: {
        1024: {
          arrows: false,
          padding: { left: 0, right: 0 },
        },
      },
    }).mount();
  })
  
}


const splideproduct = document.querySelector('.jump-splide-product');

if (splideproduct !== null) {
  new Splide(splideproduct, {
    pagination: false,
    type: 'loop',
    focus: 'center',
    autoplay: true,
    interval: 1000,
    speed: 2000,
    arrows: false,
    breakpoints: {
      1024: {
        arrows: false,
        padding: { left: 0, right: 0 },
      },
    },
  }).mount();
}
